export default class usuario {
    constructor($scope,
                $routeParams,
                method,
                usuariosService,
                empresasService,
                proyectosService,
                clientesService,
                rolesService,
                $location,
                toastr,
                $uibModal) {
        this.scope = $scope;
        this.location = $location;
        this.toastr = toastr;
        this.modal = $uibModal;
        switch (method) {
            case 'list':
                this.list(usuariosService);
                break;
            case 'new':
                this.create(usuariosService,
                    empresasService,
                    rolesService,
                    proyectosService,
                    clientesService);
                break;
            case 'view':
                this.view($routeParams,
                    usuariosService,
                    empresasService,
                    rolesService,
                    proyectosService,
                    clientesService);
                break;
            case 'cambiarpass':
                this.changepasswordpage(usuariosService)
                break;
        }
    }
    changepasswordpage(usuariosService){
        var self = this.scope;
        self.inAction = false;
        self.passwordUser = {};
        self.passwordUser.oldPassword = "";
        self.passwordUser.password = "";
        self.passwordUser.passwordConfirmed = "";
        self.changepassword = () => {
            if (!self.inAction) {
                
                if (self.passwordUser.password == self.passwordUser.passwordConfirmed) {
                    let passwordData = {
                        _id: localStorage.getItem("IdUser"),
                        id: localStorage.getItem("IdUser"), 
                        password: self.passwordUser.oldPassword,
                        newPassword: self.passwordUser.passwordConfirmed
                    };
                    usuariosService.changePassword(passwordData).then((resp) => {
                        this.toastr.success('Password guardado correctamente!', 'Success!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                        self.passwordUser = {};
                        self.passwordUser.oldPassword = "";
                        self.passwordUser.password = "";
                        self.passwordUser.passwordConfirmed = "";
                    })
                    .catch((err) => {
                        self.inAction = false;
                        this.toastr.error( 'Error al guardar el password del usuario!','Error', {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
                }else {
                    this.toastr.error( 'El password no coincide con su confirmación!','Error', {
                        timeOut: 2000,
                        closeButton: true
                    });
                }
            }
        };
    }

    list(usuariosService) {
        let self = this.scope;
        usuariosService.getAll().then((resp, err) => {
            self.usuarios = resp.data.message;
        });

        self.getItemPage = (item) => {
            let index = self.usuarios.indexOf(item);
            let pageNumber = Math.floor(index / 5) + 1;
            return pageNumber;
        };

        self.eliminar = this.eliminar.bind(this, usuariosService);

        /*
        this.scope.inAction = false;
        this.scope.eliminar = (id, index) => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                usuariosService.delete({_id: id}).then((resp) => {
                    if (resp.data.success == true) {
                        this.toastr.success('Usuario eliminado correctamente!', 'Success!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                        window.location.reload();
                    }
                })
                    .catch((err) => {
                        this.scope.inAction = false;
                        this.toastr.error( 'Error al eliminar el usuario!','Error', {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }
        };
        */
    }
   
    create(usuariosService, empresasService, rolesService, proyectosService, clientesService) {

        var self = this.scope;
        self.usuario = {};
        self.valido = false;
        self.check_user = function (user) {
            if (user === undefined) return false;

            let query = {
                usuario: user
            };
            usuariosService.getAll(query)
                .then((resp) => {
                    if (resp.data.message.length == 0) {
                        self.valido = true;
                    }
                });
        };

        self.$watch('usuario.rol', (nuevo) => {
            if (angular.isDefined(nuevo)) {
                self.usuario.permisos = nuevo.permisos;
            }
        });

        empresasService.getAll().then((resp, err) => {
            self.empresas = resp.data.message;
        });

        rolesService.getAll().then((resp, err) => {
            self.roles = resp.data.message;
        });

        self.aux = {
            proyectos: {
                options: {
                    leftContainerLabel: 'Proyectos Disponibles',
                    rightContainerLabel: 'Proyectos Seleccionados',
                    active: true
                },
                izquierda: [],
                derecha: [],
                removeVal: []
            },
            clientes: {
                options: {
                    leftContainerLabel: 'Clientes Disponibles',
                    rightContainerLabel: 'Clientes Seleccionados',
                    active: true
                },
                izquierda: [],
                derecha: [],
                removeVal: []
            }
        };

        proyectosService.getAllList().then((resp, err) => {
			let raw = resp.data.message;
			for (var k in raw) {
				let aux = raw[k];
				aux.nombre = aux.cliente.nombre + '/ ' + aux.nombre;
			}
            self.aux.proyectos.all = raw;
            self.aux.proyectos.izquierda = [];
            self.aux.proyectos.derecha = [];
        });

        clientesService.getAllList().then((resp, err) => {
            self.aux.clientes.izquierda = resp.data.message;
            self.aux.clientes.derecha = [];
        });

        let getClientes = () => {
            return self.aux.clientes.derecha.length;
        };

        let getIdProyectosSeleccionados = () => {
            let idSeleccionados = [];
            for (var indexProyecto in self.aux.proyectos.derecha) {
                idSeleccionados.push(self.aux.proyectos.derecha[indexProyecto]._id);
            }
            return idSeleccionados;
        };
        let getIdProyectosNoSeleccionados = () => {
            let idNoSeleccionados = [];
            for (var indexProyecto in self.aux.proyectos.izquierda) {
                idNoSeleccionados.push(self.aux.proyectos.izquierda[indexProyecto]._id);
            }
            return idNoSeleccionados;
        };

        this.scope.$watch(getClientes, (nuevo) => {
            //Si la lista de clientes es mayor a 0
            if (nuevo > 0) {
                //lista con todos los proyectos existentes
                let toFilter = self.aux.proyectos.all;

                let idIzq = getIdProyectosNoSeleccionados();
                let idDer = getIdProyectosSeleccionados();
                //Recorremos todos los clientes seleccionados
                for (var indexCliente in self.aux.clientes.derecha) {
                    let cliente = self.aux.clientes.derecha[indexCliente];
                    for (var el in toFilter) {
                        let element = toFilter[el];
                        //Si el proyecto pertenece a alguno de los clientes seleccionados, se agrega a la izquierda
                        //siempre que este ya no alla sido agregado
                        if (cliente._id === element.cliente._id && idIzq.indexOf(element._id) < 0
                            && idDer.indexOf(element._id) < 0) {
                            self.aux.proyectos.izquierda.push(element);
                            idIzq.push(element._id);
                        }
                    }
                }
                //Recorremos todos los clientes No seleccionados
                for (var indexClienteIzq in self.aux.clientes.izquierda) {
                    let cliente = self.aux.clientes.izquierda[indexClienteIzq];
                    for (var el in toFilter) {
                        let element = toFilter[el];
                        //Si el proyecto pertenece a alguno de losclientes No seleccionados y el proyecto esta a la derecha, se
                        //mueve a la izquierda
                        let elementId = element._id;
                        let indexDer = idDer.indexOf(element._id);
                        if (cliente._id === element.cliente._id && indexDer > -1) {
                            for (var indexProyectoDer in self.aux.proyectos.derecha) {
                                let proyecto = self.aux.proyectos.derecha[indexProyectoDer];
                                if (proyecto._id === elementId) {
                                    self.aux.proyectos.derecha.splice(indexProyectoDer, 1);
                                }
                            }
                            idDer.splice(indexDer, 1);
                        }
                        let indexIzq = idIzq.indexOf(element._id);
                        if (cliente._id === element.cliente._id && indexIzq > -1) {
                            for (var indexProyectoIzq in self.aux.proyectos.izquierda) {
                                let proyecto = self.aux.proyectos.izquierda[indexProyectoIzq];
                                if (proyecto._id === elementId) {
                                    self.aux.proyectos.izquierda.splice(indexProyectoIzq, 1);
                                }
                            }
                            idIzq.splice(indexIzq, 1);
                        }
                    }
                }
            } else {
                self.aux.proyectos.derecha = [];
                self.aux.proyectos.izquierda = [];
            }
        });

        self.inAction = false;
        self.guardar = () => {

            if(self.aux.clientes.derecha.length === 0) {
                this.toastr.error('Debe seleccionar al menos un cliente!','Error', {
                    timeOut: 2000,
                    closeButton: true
                });
                return;
            }
            if(self.aux.proyectos.derecha.length === 0) {
                this.toastr.error( 'Debe seleccionar al menos un proyecto!','Error', {
                    timeOut: 2000,
                    closeButton: true
                });
                return;
            }

            if (!self.inAction &&
                self.valido) {
                self.inAction = true;
                /** Clientes **/
                let clientesUsuarios = [];
                for (let x = 0; x < self.aux.clientes.derecha.length; x++) {
                    clientesUsuarios.push(self.aux.clientes.derecha[x]._id);
                }
                self.usuario.clientes = clientesUsuarios;

                /** Proyectos **/
                let proyectosUsuarios = [];
                for (let x = 0; x < self.aux.proyectos.derecha.length; x++) {
                    proyectosUsuarios.push(self.aux.proyectos.derecha[x]._id);
                }
                self.usuario.proyectos = proyectosUsuarios;

                /** guardar **/

                usuariosService.save(self.usuario).then((resp) => {
                    self.usuario._id = resp.data.message._id;
                    this.toastr.success('Usuario creado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/usuario');
                })
                    .catch((err) => {
                        self.inAction = false;
                        this.toastr.error( 'Error al crear el usuario!','Error', {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }
        };

    }

    view($routeParams,
         usuariosService,
         empresasService,
         rolesService,
         proyectosService,
         clientesService) {

        this.scope.aux = {
            proyectos: {
                options: {
                    leftContainerLabel: 'Proyectos Disponibles',
                    rightContainerLabel: 'Proyectos Seleccionados',
                    active: true
                },
                izquierda: [],
                derecha: [],
                removeVal: []
            },
            clientes: {
                options: {
                    leftContainerLabel: 'Clientes Disponibles',
                    rightContainerLabel: 'Clientes Seleccionados',
                    active: true
                },
                izquierda: [],
                derecha: [],
                removeVal: []
            }
        };

        this.scope.firstLoad = false;
        this.scope.firstLoadClients = false;
        this.scope.sinCorreo = false;
        usuariosService.getById({_id: $routeParams.id}).then((resp) => {
            this.scope.firstLoad = true;
            this.scope.usuario = resp.data.message;
            this.scope.sinCorreo = angular.isUndefined(this.scope.usuario.email);
            this.scope.firstLoadClients = true;
            /* Clientes */
            let clientesDer = angular.isDefined(this.scope.usuario.clientes) ? this.scope.usuario.clientes : [];
            let id_derClientes = [];

            for (var el in clientesDer) {
                let element = clientesDer[el];
                id_derClientes.push(element);
            }

            clientesService.getAllList().then((resp, err) => {
                let toFilter = resp.data.message;
                let filter = [];
                let filterDerecha = [];
                for (var el in toFilter) {
                    let element = toFilter[el];
                    if (id_derClientes.indexOf(element._id) < 0) {
                        filter.push(element);
                    } else {
                        filterDerecha.push(element);
                    }
                }
                this.scope.aux.clientes.derecha = filterDerecha;
                this.scope.aux.clientes.izquierda = filter;
                this.scope.firstLoadClients = false;

                /* Proyectos */
                let proyectosDer = angular.isDefined(this.scope.usuario.proyectos) ? this.scope.usuario.proyectos : [];
                let id_der = [];

                for (var el in proyectosDer) {
                    let element = proyectosDer[el];
                    id_der.push(element);
                }

                proyectosService.getAllList().then((resp, err) => {
                    let toFilter = resp.data.message;
                    this.scope.aux.proyectos.all = toFilter;
                    let filter = [];
                    let filterDerecha = [];
                    for (var el in toFilter) {
                        let element = toFilter[el];
						element.nombre = element.cliente.nombre + '/ ' + element.nombre;
						// console.log(element);
                        if (id_der.indexOf(element._id) < 0) {
                            if (id_derClientes.indexOf(element.cliente._id) > -1) {
                                filter.push(element);
                            }
                        } else {
                            filterDerecha.push(element);
                        }
                    }
                    this.scope.aux.proyectos.izquierda = filter;
                    this.scope.aux.proyectos.derecha = filterDerecha;
                });
            });


        }).catch((er) => {
            console.log(er);
        });

        this.scope.$watch('usuario.rol', (nuevo) => {
            if (!this.scope.firstLoad && angular.isDefined(nuevo)) {
                this.scope.usuario.permisos = nuevo.permisos;
            } else {
                this.scope.firstLoad = false;
            }
        });

        let getClientes = () => {
            return this.scope.aux.clientes.derecha.length;
        };

        let getIdProyectosSeleccionados = () => {
            let idSeleccionados = [];
            for (var indexProyecto in this.scope.aux.proyectos.derecha) {
                idSeleccionados.push(this.scope.aux.proyectos.derecha[indexProyecto]._id);
            }
            return idSeleccionados;
        };
        let getIdProyectosNoSeleccionados = () => {
            let idNoSeleccionados = [];
            for (var indexProyecto in this.scope.aux.proyectos.izquierda) {
                idNoSeleccionados.push(this.scope.aux.proyectos.izquierda[indexProyecto]._id);
            }
            return idNoSeleccionados;
        };

        this.scope.$watch(getClientes, (nuevo) => {
            if (!this.scope.firstLoadClients) {
                //Si la lista de clientes es mayor a 0
                if (nuevo > 0) {
                    //lista con todos los proyectos existentes
                    let toFilter = this.scope.aux.proyectos.all;

                    let idIzq = getIdProyectosNoSeleccionados();
                    let idDer = getIdProyectosSeleccionados();
                    //Recorremos todos los clientes seleccionados
                    for (var indexCliente in this.scope.aux.clientes.derecha) {
                        let cliente = this.scope.aux.clientes.derecha[indexCliente];
                        for (var el in toFilter) {
                            let element = toFilter[el];
                            //Si el proyecto pertenece a alguno de los clientes seleccionados, se agrega a la izquierda
                            //siempre que este ya no alla sido agregado
                            if (cliente._id === element.cliente._id && idIzq.indexOf(element._id) < 0
                                && idDer.indexOf(element._id) < 0) {
                                this.scope.aux.proyectos.izquierda.push(element);
                                idIzq.push(element._id);
                            }
                        }
                    }
                    //Recorremos todos los clientes No seleccionados
                    for (var indexClienteIzq in this.scope.aux.clientes.izquierda) {
                        let cliente = this.scope.aux.clientes.izquierda[indexClienteIzq];
                        for (var el in toFilter) {
                            let element = toFilter[el];
                            //Si el proyecto pertenece a alguno de losclientes No seleccionados y el proyecto esta a la derecha, se
                            //mueve a la izquierda
                            let elementId = element._id;
                            let indexDer = idDer.indexOf(element._id);
                            if (cliente._id === element.cliente._id && indexDer > -1) {
                                for (var indexProyectoDer in this.scope.aux.proyectos.derecha) {
                                    let proyecto = this.scope.aux.proyectos.derecha[indexProyectoDer];
                                    if (proyecto._id === elementId) {
                                        this.scope.aux.proyectos.derecha.splice(indexProyectoDer, 1);
                                    }
                                }
                                idDer.splice(indexDer, 1);
                            }
                            let indexIzq = idIzq.indexOf(element._id);
                            if (cliente._id === element.cliente._id && indexIzq > -1) {
                                for (var indexProyectoIzq in this.scope.aux.proyectos.izquierda) {
                                    let proyecto = this.scope.aux.proyectos.izquierda[indexProyectoIzq];
                                    if (proyecto._id === elementId) {
                                        this.scope.aux.proyectos.izquierda.splice(indexProyectoIzq, 1);
                                    }
                                }
                                idIzq.splice(indexIzq, 1);
                            }
                        }
                    }
                } else {
                    this.scope.aux.proyectos.derecha = [];
                    this.scope.aux.proyectos.izquierda = [];
                }
            }
        });

        empresasService.getAll().then((resp, err) => {
            this.scope.empresas = resp.data.message;
        });

        rolesService.getAll().then((resp, err) => {
            this.scope.roles = resp.data.message;
        });

        this.scope.inAction = false;
        this.scope.guardar = () => {
            if(this.scope.aux.clientes.derecha.length == 0) {
                this.toastr.error('Debe seleccionar al menos un cliente!','Error', {
                    timeOut: 2000,
                    closeButton: true
                });
                return;
            }
            if(this.scope.aux.proyectos.derecha.length == 0) {
                this.toastr.error( 'Debe seleccionar al menos un proyecto!','Error', {
                    timeOut: 2000,
                    closeButton: true
                });
                return;
            }
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                /** Clientes **/
                let clientesUsuarios = [];
                for (let x = 0; x < this.scope.aux.clientes.derecha.length; x++) {
                    clientesUsuarios.push(this.scope.aux.clientes.derecha[x]._id);
                }
                this.scope.usuario.clientes = clientesUsuarios;

                /** Proyectos **/
                let proyectosUsuarios = [];
                for (let x = 0; x < this.scope.aux.proyectos.derecha.length; x++) {
                    proyectosUsuarios.push(this.scope.aux.proyectos.derecha[x]._id);
                }
                this.scope.usuario.proyectos = proyectosUsuarios;

                usuariosService.update(this.scope.usuario).then((resp) => {
                    this.toastr.success('Usuario modificado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/usuario');
                })
                    .catch((err) => {
                        this.scope.inAction = false;
                        this.toastr.error( 'Error al modificar el usuario!', 'Error',{
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }
        };
        this.scope.aux.sendPassword = this.enviarClave.bind(this, usuariosService);

    }

    enviarClave(usuariosService) {
        if (!this.scope.usuario.correo && !this.scope.sinCorreo) {
            this.toastr.error('El usuario debe tener un correo ingresado', 'Error!', {
                timeOut: 2000,
                closeButton: true
            });
            return;
        }
        if (!this.scope.inAction) {
            this.scope.inAction = true;
            usuariosService.sendPassword({_id: this.scope.usuario._id}).then((resp) => {
                if (resp.data.success) {
                    this.toastr.success('Clave reseteada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/usuario');
                } else {
                    this.toastr.error('Error al resetear clave', 'Error!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                }
                this.scope.inAction = false;
            })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error al enviar clave', 'Error!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
        }
    }

    eliminar(service,object, page, index) {
        let self = this;
        let templateModal = `
			    <div class="modal-content">
			      <div class="modal-header">
			        <h4 class="modal-title" id="myModalLabel">Eliminar Usuario</h4>
			      </div>
			      <div class="modal-body">
                		¿Quiere eliminar al Usuario: {{ctr.nombre}}?
			      </div>
			      <div class="modal-footer">
			        <button type="button" class="btn btn-default" ng-click="ctr.no()">NO</button>
			        <button type="button" class="btn btn-primary" ng-click="ctr.si()">SI</button>
			      </div>
			    </div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function () {
                let vm = this;
                vm.nombre = object.usuario;
                this.no = () => {
                    let data = {
                        delete: false
                    };
                    modal.close(data);
                };

                this.si = () => {
                    let data = {
                        delete: true,
                        index: (page - 1) * 5 + index
                    };
                    modal.close(data);
                };
            },
            controllerAs: 'ctr',
            size: 'md'
        });

        modal.result.then((resp) => {
            if (resp.delete) {
                let indexObject = resp.index;
                self.inAction = true;
                service.delete({_id: object._id}).then((resp) => {
                    self.scope.usuarios.splice(indexObject, 1);
                    self.inAction = false;
                    this.toastr.success('Usuario eliminado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                })
                    .catch((err) => {
                        self.inAction = false;
                        this.toastr.error('Error al eliminar al Usuario!','Error',  {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }

        }, (exit) => {
            console.log('modal close');
        });
    }
}



// WEBPACK FOOTER //
// ./app/js/controllers/usuario/usuario.js